import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconFolderPlusCircle = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24h-24v-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M20.241 14.996c0 0 1.007-3.433 1.007-3.433 .376-1.281-.584-2.563-1.919-2.563h-9.841c-.883 0-1.662.579-1.916 1.426l-2.327 7.757c-.145.485-.592.817-1.098.817v0c-.634 0-1.147-.513-1.147-1.147v-12.853c0-1.105.895-2 2-2h4.465c.334 0 .646.167.832.446l1.406 2.109c.185.278.498.445.832.445h4.465c1.105 0 2 .895 2 2v1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M16.5 22c-2.485 0-4.5-2.015-4.5-4.5 0-2.485 2.015-4.5 4.5-4.5 2.486 0 4.5 2.015 4.5 4.5 0 2.485-2.014 4.5-4.5 4.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "12.26",
    x2: "4.15",
    y1: "19",
    y2: "19",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  }), /*#__PURE__*/React.createElement("line", {
    x1: "15.12",
    x2: "18.12",
    y1: "17.38",
    y2: "17.38",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.62",
    x2: "16.62",
    y1: "18.88",
    y2: "15.88",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  })));
};
//# sourceMappingURL=IconFolderPlusCircle.js.map